import { all, call, put, takeLatest, select } from "redux-saga/effects";
import * as jsonpatch from "fast-json-patch";
import cloneDeep from "lodash.clonedeep";
import httpClient from "./http-client";
import { createJobFailure,
  createJobRequested,
  createJobSuccess,
  CREATE_JOB,
  UPDATE_JOB,
  fetchJobsFailure,
  fetchJobsRequested,
  fetchJobsSuccess,
  FETCH_JOBS,
  FETCH_JOB_BY_ID,
  fetchJobByIdFailure,
  fetchJobByIdSuccess,
  fetchJobByIdRequested,
  fetchJobById,
  updateJobFailure,
  updateJobSuccess,
  updateJobRequested,
  fetchJobs,
  UPDATE_JOB_WITH_STATUS,
  UPDATE_JOB_DELIVERY_DATE } from "../actions/jobs-actions-types";
import { toggleSnackBar } from "../actions/app-action-types";
import { fetchBusinessChartsData } from "../actions/analytics-action-types";

export function* addJobHandler({ payload }) {
  yield put(createJobRequested());

  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const request = {
    data: {
      payload: {
        userId,
        item: payload.item,
        customerName: payload.customerName.trim(),
        customerAddress: payload.customerAddress,
        deliveryDate: payload.deliveryDate.getTime(),
        deliveryTime: `${payload.deliveryTime}${payload.timeSlot.toLowerCase()}`,
        customerEmail: payload.customerEmail,
        serviceCost: payload.serviceCost,
        status: payload.status,
        type: payload.type,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        isDeleted: false,
      },
    },
    method: "POST",
    url: "/api/v1/jobs",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(createJobFailure(error));
  } else {
    const jobId = data.details.id;

    yield put(fetchJobById(jobId));
    yield put(fetchBusinessChartsData());
    yield put(createJobSuccess(data));
  }
}

export function* updateJobHandler({ payload }) {
  yield put(updateJobRequested());
  const jobs = yield select((state) => state?.jobs?.jobs);
  const updatedJobs = cloneDeep(jobs);

  let existingJob = { ...payload };

  if (payload.deliveryTime && payload.timeSlot) {
    existingJob = {
      ...existingJob,
      deliveryTime: `${payload.deliveryTime}${payload.timeSlot.toLowerCase()}`,
    };
  }
  const singleJob = updatedJobs.find((job) => job.identifier === payload.identifier);
  const updates = {
    ...singleJob,
    ...existingJob,
  };

  const diffPayload = jsonpatch.compare(singleJob, updates);

  if (diffPayload.length) {
    const request = {
      data: { payload: diffPayload },
      method: "PATCH",
      url: `/api/v1/jobs/${payload.identifier}`,
    };

    const {
      data, error,
    } = yield call(httpClient, request, true);

    if (error) {
      yield put(updateJobFailure(error));
    } else {
      yield put(fetchJobs());
      yield put(updateJobSuccess(data));
    }
  }
}

export function* fetchAllJobsHandler() {
  yield put(fetchJobsRequested());

  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const request = {
    method: "GET",
    params: {
      userId, sort: "asc",
    },
    url: "/api/v1/jobs",
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchJobsFailure(error));
  } else {
    yield put(fetchJobsSuccess(data.details));
  }
}

export function* fetchJobByIdHandler({ payload }) {
  yield put(fetchJobByIdRequested());

  const request = {
    method: "GET",
    url: `/api/v1/jobs/${payload}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchJobByIdFailure(error));
  } else {
    yield put(fetchJobByIdSuccess(data.details));
  }
}

export function* updateJobWithStatusHandler({ payload }) {
  yield put(updateJobRequested());

  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const {
    quoteId, identifier, status, timeSlot, comments, amount,
  } = payload;

  const request = {
    method: "PATCH",
    params: {
      userId, quoteId, jobId: identifier, status, timeSlot, comments, amount,
    },
    url: "/api/v1/updateJob",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(updateJobFailure(error));
  } else {
    yield put(fetchJobs());
    yield put(updateJobSuccess(data));
  }
}

export function* updateJobDeliveryDateHandler({ payload }) {
  const {
    jobId, quoteId, time, status,
  } = payload;

  const request = {
    method: "PATCH",
    params: {
      quoteId, jobId, status, time,
    },
    url: "/api/v1/updateStatus",
  };
  const options = {
    message: "Information saved successfully",
    severity: "success",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(toggleSnackBar("Something went wrong."));
  } else {
    yield put(fetchJobs());
    yield put(toggleSnackBar(options));
  }
}

function* Job() {
  yield all([
    takeLatest(CREATE_JOB, addJobHandler),
    takeLatest(UPDATE_JOB, updateJobHandler),
    takeLatest(FETCH_JOBS, fetchAllJobsHandler),
    takeLatest(FETCH_JOB_BY_ID, fetchJobByIdHandler),
    takeLatest(UPDATE_JOB_WITH_STATUS, updateJobWithStatusHandler),
    takeLatest(UPDATE_JOB_DELIVERY_DATE, updateJobDeliveryDateHandler),
  ]);
}

export default Job;
